import { Login } from "@pages/login/ui";
import { Dashboard } from "@pages/dashboard/ui";
import { Author } from "@pages/author/ui";
import { Banner } from "@pages/banner/ui";
import { Country } from "@pages/country/ui";
import { District } from "@pages/district/ui";
import { Feedback } from "@pages/feedback/ui";
import { Genre } from "@pages/genre/ui";
import { Membership } from "@pages/membership/ui";
import { State } from "@pages/state/ui";
import { Roles } from "@pages/roles/ui";
import { Voices } from "@pages/voices/ui";
import ForgotPassword from "@pages/forgot-password/ui";
import ResetPassword from "@pages/reset-password/ui";
import AddCountry from "@pages/country/ui/add-country";
import AddState from "@pages/state/ui/add-state";
import AddDistrict from "@pages/district/ui/add-district";
import AddGenre from "../pages/genre/ui/add-genre";
import AddFeedBack from "../pages/feedback/ui/add-feedback";
import AddRole from "../pages/roles/ui/add-role";
import AddVoice from "../pages/voices/ui/add-voice";
import AddBanner from "../pages/banner/ui/add-banner";
import AddAuthor from "../pages/author/ui/add-author";
import AddMembership from "../pages/membership/ui/add-membership";
import { Posts } from "../pages/post/ui";
import AddPost from "../pages/post/ui/add-post";
import { Medias } from "../pages/media/ui";
import AddMedia from "../pages/media/ui/add-media";
import { Contents } from "../pages/content-units/ui";
import { AddContent } from "../pages/content-units/ui/add-content";
import { User } from "../pages/users/ui";
import AddUser from "../pages/users/ui/add-user";
import UserProfile from "../pages/profile/ui";
import { Purchase } from "../pages/purchase-log/ui";
import { DASHBOARD_VIEW_ID, LOG_VIEW_ID, MASTER_CREATE_ID, MASTER_EDIT_ID, MASTER_LIST_ID, MEDIA_CREATE_ID, MEDIA_LIST_ID, MEDIA_UPDATE_ID, POST_CREATE_ID, POST_LIST_ID, POST_UPDATE_ID, USER_CREATE_ID, USER_EDIT_ID, USER_LIST_ID } from "../helpers/permission/constant-permissions";
import { CustomerFeedback } from "../pages/customer-feedback-log/ui";

export const nonAuthRoutes = [
  {
    name: "login",
    path: "/login",
    component: <Login />,
    permission: true,
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    component: <ForgotPassword />,
    permission: true,
  },

  {
    name: "reset-password",
    path: "/reset-password",
    component: <ResetPassword />,
    permission: true,
  },
];

export const authRoutes = [
  {
    name: "profile",
    path: "/profile/edit/:id",
    exact: true,
    component: <UserProfile />,
    permission: USER_EDIT_ID,
  },
  // {
  //   name: "contents",
  //   path: "/contents",
  //   exact: true,
  //   component: <Contents />,
  // },
  {
    name: "contents",
    path: "/contents/edit/:id",
    exact: true,
    component: <AddContent />,
    permission: true,
  },
  {
    name: "medias",
    path: "/medias",
    exact: true,
    component: <Medias />,
    permission: MEDIA_LIST_ID,
  },
  {
    name: "medias",
    path: "/medias/add",
    exact: true,
    component: <AddMedia />,
    permission: MEDIA_CREATE_ID,
  },
  {
    name: "medias",
    path: "/medias/edit/:id",
    exact: true,
    component: <AddMedia />,
    permission: MEDIA_UPDATE_ID,
  },
  {
    name: "posts",
    path: "/posts",
    exact: true,
    component: <Posts />,
    permission: POST_LIST_ID,
  },
  {
    name: "posts",
    path: "/posts/add",
    exact: true,
    component: <AddPost />,
    permission: POST_CREATE_ID,
  },
  {
    name: "posts",
    path: "/posts/edit/:id",
    exact: true,
    component: <AddPost />,
    permission: POST_UPDATE_ID,
  },
  {
    name: "author",
    path: "/author",
    exact: true,
    component: <Author />,
    permission: MASTER_LIST_ID,
  },

  {
    name: "author",
    path: "/author/add",
    exact: true,
    component: <AddAuthor />,
    permission: MASTER_CREATE_ID,
  },
  {
    name: "author",
    path: "/author/edit/:id",
    exact: true,
    component: <AddAuthor />,
    permission: MASTER_EDIT_ID,
  },
  {
    name: "dashboard",
    path: "/dashboard",
    exact: true,
    component: <Dashboard />,
    permission: true,
  },
  {
    name: "banner",
    path: "/banner",
    exact: true,
    component: <Banner />,
    permission: MASTER_LIST_ID,
  },
  {
    name: "banner",
    path: "/banner/add",
    exact: true,
    component: <AddBanner />,
    permission: MASTER_CREATE_ID,
  },
  {
    name: "banner",
    path: "/banner/edit/:id",
    exact: true,
    component: <AddBanner />,
    permission: MASTER_EDIT_ID,
  },

  {
    name: "dashboard",
    path: "/dashboard",
    exact: true,
    component: <Dashboard />,
    permission: DASHBOARD_VIEW_ID,
  },
  {
    name: "country",
    path: "/country",
    exact: true,
    component: <Country />,
    permission: MASTER_LIST_ID,
  },
  {
    name: "country",
    path: "/country/add",
    exact: true,
    component: <AddCountry />,
    permission: MASTER_CREATE_ID,
  },
  {
    name: "country",
    path: "/country/edit/:id",
    exact: true,
    component: <AddCountry />,
    permission: MASTER_EDIT_ID,
  },

  {
    name: "feedback",
    path: "/feedback",
    exact: true,
    component: <Feedback />,
    permission: MASTER_LIST_ID,
  },
  {
    name: "feedback",
    path: "/feedback/add",
    exact: true,
    component: <AddFeedBack />,
    permission: MASTER_CREATE_ID,
  },
  {
    name: "feedback",
    path: "/feedback/edit/:id",
    exact: true,
    component: <AddFeedBack />,
    permission: MASTER_EDIT_ID,
  },
  {
    name: "district",
    path: "/district",
    exact: true,
    component: <District />,
    permission: MASTER_LIST_ID,
  },
  {
    name: "district",
    path: "/district/add",
    exact: true,
    component: <AddDistrict />,
    permission: MASTER_CREATE_ID,
  },
  {
    name: "district",
    path: "/district/edit/:id",
    exact: true,
    component: <AddDistrict />,
    permission: MASTER_EDIT_ID,
  },
  {
    name: "genre",
    path: "/genre",
    exact: true,
    component: <Genre />,
    permission: MASTER_LIST_ID,
  },
  {
    name: "genre",
    path: "/genre/add",
    exact: true,
    component: <AddGenre />,
    permission: MASTER_CREATE_ID,
  },
  {
    name: "genre",
    path: "/genre/edit/:id",
    exact: true,
    component: <AddGenre />,
    permission: MASTER_EDIT_ID,
  },
  {
    name: "membership",
    path: "/membership",
    exact: true,
    component: <Membership />,
    permission: MASTER_LIST_ID,
  },
  {
    name: "membership",
    path: "/membership/add",
    exact: true,
    component: <AddMembership />,
    permission: MASTER_CREATE_ID,
  },
  {
    name: "membership",
    path: "/membership/edit/:id",
    exact: true,
    component: <AddMembership />,
    permission: MASTER_EDIT_ID,
  },
  {
    name: "state",
    path: "/state",
    exact: true,
    component: <State />,
    permission: MASTER_LIST_ID,
  },
  {
    name: "state",
    path: "/state/add",
    exact: true,
    component: <AddState />,
    permission: MASTER_CREATE_ID,
  },
  {
    name: "state",
    path: "/state/edit/:id",
    exact: true,
    component: <AddState />,
    permission: MASTER_EDIT_ID,
  },
  // {
  //   name: "roles",
  //   path: "/roles",
  //   exact: true,
  //   component: <Roles />,
  //   permission: ,
  // },
  // {
  //   name: "roles",
  //   path: "/roles/add",
  //   exact: true,
  //   component: <AddRole />,
  //   permission: ,
  // },
  // {
  //   name: "roles",
  //   path: "/roles/edit/:id",
  //   exact: true,
  //   component: <AddRole />,
  //   permission: ,
  // },
  {
    name: "voices",
    path: "/voices",
    exact: true,
    component: <Voices />,
    permission: MASTER_LIST_ID,
  },
  {
    name: "voices",
    path: "/voices/add",
    exact: true,
    component: <AddVoice />,
    permission: MASTER_CREATE_ID,
  },
  {
    name: "voices",
    path: "/voices/edit/:id",
    exact: true,
    component: <AddVoice />,
    permission: MASTER_EDIT_ID,
  },
  {
    name: "users",
    path: "/users",
    exact: true,
    component: <User />,
    permission: USER_LIST_ID,
  },
  {
    name: "users",
    path: "/users/add",
    exact: true,
    component: <AddUser />,
    permission: USER_CREATE_ID,
  },
  {
    name: "users",
    path: "/users/edit/:id",
    exact: true,
    component: <AddUser />,
    permission: USER_EDIT_ID,
  },
  {
    name: "purchases",
    path: "/purchases",
    exact: true,
    component: <Purchase />,
    permission: MASTER_LIST_ID,
  },
  {
    name: "feedback-log",
    path: "/feedback-log",
    exact: true,
    component: <CustomerFeedback />,
    permission:LOG_VIEW_ID
  }
];
